/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-props-no-spreading */
import { useForm } from '@folklore/forms';
import { useUrlGenerator } from '@folklore/routes';
import PropTypes from 'prop-types';
import { useCallback, useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'wouter';

import useSetUser from '../../hooks/useSetUser';

import StyledButton from '../buttons/StyledButton';
import PincodeField from '../fields/Pincode';
import Dialog from './Dialog';
import Modal from './Modal';

import styles from '../../../styles/modals/scene-bonus-modal.module.scss';

import sceneCard from '../../../img/iganoel2024/scenecard.png';

const propTypes = {
    onClose: PropTypes.func,
};

const defaultProps = {
    onClose: null,
};

const SceneBonusModal = ({ onClose }) => {
    const { locale } = useIntl();
    const [opened, setOpened] = useState(true);
    const setUser = useSetUser();
    const [, setLocation] = useLocation();
    const route = useUrlGenerator();
    const onRequestClose = useCallback(() => {
        setOpened(false);
    }, []);

    const action = route('profile.field');

    const fieldNames = useMemo(() => ['scene_number'], []);

    const onComplete = useCallback((newUser) => {
        setUser(newUser);
        setLocation(
            route('game', {
                game: 'bonus',
            }),
        );
        setOpened(false);
    }, []);

    const {
        fields: formFields,
        onSubmit,
        errors,
        loading,
        generalError = null,
    } = useForm({
        fields: fieldNames,
        initialValue: {
            scene_number: null,
        },
        action,
        onComplete,
    });

    const { scene_number: numberErrors = null } = errors || {};

    return (
        <Modal withSafe opened={opened} onClosed={onClose}>
            <Dialog withCloseButton onClickClose={onRequestClose} className={styles.container}>
                <h4 className={styles.title}>
                    <FormattedMessage
                        defaultMessage="Scene+ Exclusive"
                        description="Scene bonus modal title"
                    />
                </h4>
                <div className={styles.description}>
                    <FormattedMessage
                        defaultMessage="Enter your Scene+ card number to unlock the bonus game and get a chance to win 500 Scene+ points!"
                        description="Scene bonus modal description"
                    />
                </div>

                <img src={sceneCard} className={styles.sceneCard} alt="Scene card" />

                <div className={styles.account}>
                    <FormattedMessage
                        defaultMessage="Not a member yet?"
                        description="Scene bonus modal"
                    />
                    <br />
                    <a
                        href={
                            locale === 'fr'
                                ? 'https://www.sceneplus.ca/fr-ca/register'
                                : 'https://www.sceneplus.ca/register'
                        }
                        target="_blank"
                    >
                        <FormattedMessage
                            defaultMessage="Sign up"
                            description="Scene bonus modal"
                        />
                    </a>
                </div>

                <form action="#" className={styles.form} onSubmit={onSubmit}>
                    <PincodeField
                        {...formFields.scene_number}
                        placeholder="000000 000 000 000 0"
                        className={styles.field}
                    />
                    {numberErrors !== null && numberErrors.length > 0 ? (
                        <div className={styles.error}>{numberErrors.join(<br />)}</div>
                    ) : null}
                    <div className={styles.buttons}>
                        <StyledButton className={styles.cancel}>
                            <FormattedMessage defaultMessage="Cancel" />
                        </StyledButton>
                        <StyledButton type="submit" className={styles.submit}>
                            <FormattedMessage defaultMessage="Confirm" />
                        </StyledButton>
                    </div>
                </form>
            </Dialog>
        </Modal>
    );
};

SceneBonusModal.propTypes = propTypes;
SceneBonusModal.defaultProps = defaultProps;

export default SceneBonusModal;
